/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2024, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { InlineNotification, Link } from 'carbon-components-react';
import urlJoin from 'proper-url-join';
import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { selectAssistant } from '@ibm-watson/shared/modules/ia/store/assistants/core-selectors';
import { selectInstanceId } from '@ibm-watson/shared/modules/ia/store/session/selectors';
import history from '@ibm-watson/shared/modules/ia/util/history';
import { SSL_SELECTION } from '../../../../ts/assistant';
import messages from './messages';

import './SslNotification.scss';

interface SslNotificationProps {
  callback?: () => void;
}

export const SslNotification = ({ callback }: SslNotificationProps) => {
  const formatMsg = useIntl().formatMessage;
  const instanceId = useSelector(selectInstanceId);
  const assistant = useSelector(selectAssistant);

  return (
    (assistant?.certification_method === SSL_SELECTION.UPLOAD ||
      assistant?.certification_method === SSL_SELECTION.UPLOAD_ANY) && (
      <InlineNotification
        kind="warning"
        lowContrast
        title={formatMsg(messages.sslConfigured)}
        subtitle={
          <FormattedMessage
            {...messages.sslConfiguredDescription}
            values={{
              a: text => (
                <Link
                  className="SslNotification__link"
                  onClick={() => {
                    callback();
                    history.push(
                      urlJoin(
                        document.baseURI,
                        encodeURIComponent(instanceId),
                        'assistants',
                        assistant?.assistant_id,
                        'settings'
                      )
                    );
                  }}>
                  {text}
                </Link>
              )
            }}
          />
        }
      />
    )
  );
};
